export const LOGIN_ADMIN = "LOGIN_ADMIN";
export const LOGOUT_ADMIN = "LOGOUT_ADMIN";
export const GET_ALL_CATEGORIES = "GET_ALL_CATEGORIES";
export const ADD_CATEGORIES = "ADD_CATEGORIES";
export const DELETE_CATEGORIES = "DELETE_CATEGORIES";
export const EDIT_STATUS_CATEGORIES = "EDIT_STATUS_CATEGORIES";
export const EDIT_FEATURES_CATEGORIES = "EDIT_FEATURES_CATEGORIES";
export const EDIT_CATEGORY = "EDIT_CATEGORY";
export const GET_ALL_CATEGORIES_ADS = "GET_ALL_CATEGORIES_ADS";
export const ADD_CATEGORY_ADS = "ADD_CATEGORY_ADS";
export const DELETE_CATEGORY_ADS = "DELETE_CATEGORY_ADS";
export const EDIT_STATUS_CATEGORY_ADS = "EDIT_STATUS_CATEGORY_ADS";
export const EDIT_CATEGORY_ADS = "EDIT_CATEGORY_ADS";

export const GET_MAIN_ADS = "GET_MAIN_ADS";
export const ADD_MAIN_ADS = "ADD_MAIN_ADS";
export const DELETE_MAIN_ADS = "DELETE_MAIN_ADS";
export const EDIT_STATUS_MAIN_ADS = "EDIT_STATUS_MAIN_ADS";
export const EDIT_MAIN_ADS = "EDIT_MAIN_ADS";

export const GET_USERS = "GET_USERS";

export const GET_ALL_PACKAGES = "GET_ALL_PACKAGES";
export const ADD_PACKAGE = "ADD_PACKAGE";
export const DELETE_PACKAGE = "DELETE_PACKAGE";
export const EDIT_STATUS_PACKAGE = "EDIT_STATUS_PACKAGE";
export const EDIT_PACKAGE = "EDIT_PACKAGE";
export const ADD_FEATURES = "ADD_FEATURES";
export const GET_FEATURES = "GET_FEATURES";
export const EMPTY_FEATURES = "EMPTY_FEATURES";
export const DELETE_FEATURE = "DELETE_FEATURE";
export const EDIT_FEATURE = "EDIT_FEATURE";

export const GET_ALL_SUBCATEGORY = "GET_ALL_SUBCATEGORY";
export const ADD_SUBCATEGORY = "ADD_SUBCATEGORY";
export const DELETE_SUBCATEGORY = "DELETE_SUBCATEGORY";
export const EDIT_STATUS_SUBCATEGORY = "EDIT_STATUS_SUBCATEGORY";
export const EDIT_SUBCATEGORY = "EDIT_SUBCATEGORY";
export const GET_SUBCATEGORY_BY_ID = "GET_SUBCATEGORY_BY_ID";
export const GET_ALL_DAYS = "GET_ALL_DAYS";
export const GET_SOCIAL_MEDIA = "GET_SOCIAL_MEDIA";

export const ADD_VENDOR = "ADD_VENDOR";
export const EDIT_VENDOR = "EDIT_VENDOR";
export const GET_ALL_VENDORS = "GET_ALL_VENDORS";
export const DELETE_VENDORS = "DELETE_VENDORS";
export const EDIT_STATUS_VENDORS = "EDIT_STATUS_VENDORS";
export const GET_ONE_VENDORS = "GET_ONE_VENDORS";
export const EMPTY_ONE_VENDOR = "EMPTY_ONE_VENDOR";

export const GET_ALL_BANNERS = "GET_ALL_BANNERS";
export const ADD_BANNER = "ADD_BANNER";
export const DELETE_BANNER = "DELETE_BANNER";
export const EDIT_STATUS_BANNER = "EDIT_STATUS_BANNER";
export const EDIT_BANNER = "EDIT_BANNER";

export const GET_ALL_SOCIAL = "GET_ALL_SOCIAL";
export const ADD_SOCIAL = "ADD_SOCIAL";
export const DELETE_SOCIAL = "DELETE_SOCIAL";
export const EDIT_SOCIAL = "EDIT_SOCIAL";

export const GET_ABOUT = "GET_ABOUT";
export const EDIT_ABOUT = "EDIT_ABOUT";
export const GET_PRIVACY = "GET_PRIVACY";
export const EDIT_PRIVACY = "EDIT_PRIVACY";

export const GET_ALL_STROIES = "GET_ALL_STROIES";
export const GET_STROIY_DETAILS = "GET_STROIY_DETAILS";
export const EMPTY_STROIY_DETAILS = "EMPTY_STROIY_DETAILS";
export const DELETE_STROIY = "DELETE_STROIY";
export const ADD_STROIY = "ADD_STROIY";
export const DELETE_STROIY_DETAILS = "DELETE_STROIY_DETAILS";
export const ADD_TO_VENDOR = "ADD_TO_VENDOR";


export const GET_ALL_REVIEWS = "GET_ALL_REVIEWS";
export const EDIT_STATUS_REVIEWS = "EDIT_STATUS_REVIEWS";
export const DELETE_REVIEW = "DELETE_REVIEW";

export const GET_ALL_REELS = "GET_ALL_REELS";
export const ADD_REELS = "ADD_REELS";
export const DELETE_REELS = "DELETE_REELS";

export const SEND_NOTIFICATIONS = "SEND_NOTIFICATIONS";
export const ADD_FEATURE_TO_VENDOR = "ADD_FEATURE_TO_VENDOR";


export const DELETE_DAY_VENDOR = "DELETE_DAY_VENDOR";
export const DELETE_SOCIAL_VENDOR = "DELETE_SOCIAL_VENDOR";